import NiceModal from '@ebay/nice-modal-react';

import { useGetPaymentTypes } from '../api/getPaymentTypes';

import { AddModal } from './AddModal';
import { PaymentTypesTable } from './Table/Table';

import { AddButton, ListLoader } from '@/components';

export const PaymentTypesList = () => {
  const { data, isLoading } = useGetPaymentTypes();

  if (isLoading) {
    return <ListLoader />;
  }

  if (!data?.paymentTypes.length) {
    return <ListAddButton isLoading={isLoading} />;
  }

  return (
    <div>
      <PaymentTypesTable paymentTypes={data.paymentTypes} />
      <ListAddButton isLoading={isLoading} />
    </div>
  );
};

function ListAddButton({ isLoading }: { isLoading: boolean }) {
  return (
    <AddButton
      isLoading={isLoading}
      size={60}
      onClick={() =>
        NiceModal.show(AddModal, {
          initialValues: {
            name: '',
            key: '',
            isPartial: false,
          },
        })
      }
    />
  );
}
